import React, { useState } from "react";
import CustomForm from "@sistemas.mundo/custom-form";
import useRegistro from "../../../../queries/login/useRegistro";

const CambioCorreo = () => {
  const queryCambioCorreo = useRegistro();
  const [tokenCaptcha, setTokenCaptcha] = useState(null);
  const onSuccess = (token) => {
    setTokenCaptcha(token);
  };
  const onExpired = () => {
    setTokenCaptcha(null);
  };
  const camposFormulario = () => {
    return [
      {
        title: "",
        elements: [
          {
            name: "nuevo_correo",
            label: "Correo electrónico",
            placeholder: "ejemplo@tuemail.com",
            value: null,
            type: "email",
            required: true,
            onChange: null,
            customValidation: null,
            customFormat: null,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
          {
            name: "nuevo_correo_2",
            label: "Reingresa correo electrónico",
            placeholder: "ejemplo@tuemail.com",
            value: null,
            type: "email",
            required: true,
            onChange: null,
            customValidation: (e) => {
              const form = document.getElementById("cambio_correo");
              const x = form.querySelector("#nuevo_correo");
              if (x.value == e) {
                return {
                  message: "",
                  isValid: true,
                };
              }
              return {
                message: "Los correos no coinciden",
                isValid: false,
              };
            },
            customFormat: null,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },

          {
            name: "recaptcha",
            label: "reCAPTCHA",
            value: null,
            type: "recaptcha",
            keyRecaptcha: "6LdRU8woAAAAAIPZLtfJeId4jpXHNi-hfQpbK39k",
            onSuccesscaptcha: onSuccess,
            onExpiredcaptcha: onExpired,
            token: tokenCaptcha,
            required: true,
            onChange: null,
            customValidation: null,
            customFormat: null,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
        ],
      },
    ];
  };

  const onSubmit = (data) => {
    const form = document.getElementById("formulario_login");
    const rut = form.querySelector("#RutCliente");
    const numeroDocumento = form.querySelector("#numeroDocumento");

    const formData = {
      clie_correo: data.nuevo_correo,
      clie_num_serie: numeroDocumento.value,
      clie_rut: rut.value,
      origen: "email",
      token_captcha: tokenCaptcha,
    };
    queryCambioCorreo.mutate(formData);
  };

  return (
    <CustomForm
      formId="cambio_correo"
      campos={camposFormulario()}
      showClearForm={false}
      onSubmit={onSubmit}
      submitButtonText={"CAMBIAR CORREO"}
      tooltipSubmitBtn={"CAMBIAR CORREO"}
      submitButtonPosition="center"
      fullButtonSubmitWidth={true}
      resetCamposOnSubmit={false}
    />
  );
};

export default CambioCorreo;
